<template>
  <div class="footer_box">
    <!-- 底部 -->
    <el-row class="footer_content">
      <!-- logo -->
      <el-col :span="3" style="height: 10px"></el-col>
      <el-col :span="5" class="footer_leftContent">
        <img src="~@/assets/images/BOSlogoWhite.png" />
      </el-col>
      <el-col :span="4" style="height: 10px"></el-col>
      <el-col :span="10">
        <ul class="footer_rightContent">
          <li>电话：0731-85651520</li>
          <li>湖南长沙市天心区芙蓉中路二段200号新世纪大厦七楼</li>
          <li>
            Copyright2018-2020 lanhaigo.com 营业执照
            <span class="linkStyle" @click="openUrl">湘ICP备13003169号-5</span>
            <!-- <span class="linkStyle" @click="openUrl">沪ICP备18028331号</span>湘ICP备13003169号-5 -->
          </li>
        </ul>
      </el-col>
      <!-- <el-col :span="6" style="height: 10px"></el-col> -->
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {},
  data() {
    return {
      activeIndex: "1", //默认选中导航
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    openUrl() {
      window.open("https://beian.miit.gov.cn", "_blank");
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style scoped lang="scss">
.footer_box {
  background: #0a1633;
  height: 170px;
  color: #c5c5c5;
  font-size: 16px;
  padding-top: 72px;

  .footer_leftContent {
    padding-top: 7px;
    text-align: left;
    margin-left: 17px;
  }
  ul li {
    list-style: none;
    font-family: MicrosoftYaHeiLight;
    font-weight: 400;
    line-height: 25px;
    font-size: 14px;
  }

  p {
    margin-top: 22px;
    line-height: 32px;
  }

  .footer_rightContent {
    margin-right: 17px;
    text-align: right;
    .linkStyle {
      text-decoration: none;
      color: #c5c5c5;
      cursor: pointer;
    }

    .linkStyle:hover {
      text-decoration: underline;
    }
  }
}
</style>
